import { isPdfSource } from './PdfViewer';

export const viewUploadedFile = ({ fileUrl, fileName, mimeType, onPdf }) => {
  if (!fileUrl) return;

  if (isPdfSource(fileName, mimeType)) {
    onPdf?.();
    return;
  }

  window.open(fileUrl, '_blank', 'noopener,noreferrer');
};

export const downloadUploadedFile = (fileUrl, fileName) => {
  if (!fileUrl) return;

  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = fileName || 'document';
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
};
